import {createFileRoute, redirect} from '@tanstack/react-router'

export const Route = createFileRoute('/_app/projects/create/')({
    beforeLoad: () => {
        throw redirect({to: '/jobs/create', replace: true})
    },
})
